import React, { useState } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import { getFromLocalStorage, saveToLocalStorage } from "../../../utils/Util";
import { Button, Dialog } from '@material-ui/core';
import { IconWithTooltip } from '../icons/IconWithTooltip';
import { PaperComponent } from '../DraggablePaper';
import ErrorAwareTextField from '../inputfields/ErrorAwareTextField';

export function CookieSetter({ cookieObjects, tableName }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [settings, setSettings] = useState();

    const handleDialogOpen = () => {
        setDialogOpen(true);
        getCookies();
    }

    const handleDialogClose = () => {
        console.log("close");
        setDialogOpen(false);
    }

    const handleSubmit = (e) => {
        console.log("submit");
        saveToLocalStorage(tableName, 'settings', settings);
    }

    const getCookies = () => {
        const cookies = getFromLocalStorage(tableName, 'settings');
        if (cookies) {
            setSettings(cookies);
        } else {
            setSettings(cookieObjects);
        }
    }

    const handleChange = (event) => {
        const newSettings = []
        settings.forEach(function (obj) {
            if (obj.name === event.target.name) {
                const newObject = {
                    name: obj.name,
                    value: event.target.value,
                    label: obj.label
                }
                newSettings.push(newObject);
            } else {
                newSettings.push(obj);
            }
        })
        setSettings(newSettings);
    }

    return (
        <>
            <Button onClick={handleDialogOpen}>
                <IconWithTooltip title={'Beállítások'} >
                    <CreateIcon />
                </IconWithTooltip>
            </Button>
            <Dialog disableBackdropClick
                disableScrollLock
                PaperComponent={PaperComponent}
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="form-dialog-title">
                <div className="modal-form">
                    <button className="close-modal-btn lnr-cross" onClick={handleDialogClose}></button>
                    <h2 id="draggable-dialog-title">{'Beállítások'}</h2>
                    <form onSubmit={handleSubmit}>
                        {settings && settings.map(setting => {
                            return (
                                <div className='input-group'>
                                    <ErrorAwareTextField
                                        name={setting.name}
                                        label={setting.label}
                                        value={setting.value}
                                        onChange={handleChange}
                                    />
                                </div>)
                        })}

                        <div className="form-actions">
                            <Button className="btn-submit" variant="contained" color="primary" type="submit">
                                Beállít
                            </Button>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    )
}